export default {
  completeProfile: {
    intro: {
      title: "Configuriamo tutto",
      subtitle: "Alcune rapide autorizzazioni ci aiutano a mostrare quote più pertinenti, inviare aggiornamenti tempestivi e migliorare la tua esperienza.",
    },
    tracking: {
      title: "Aiuta a mantenere Linemate gratuito",
      subtitle: "Ti chiediamo il permesso di tracciare alcune attività su questo dispositivo. Selezionando “Consenti tracciamento” nella prossima schermata, ci aiuterai a:",
      buttonSubtext: "Puoi modificare questa opzione più tardi nell'app Impostazioni",
      cards: {
        support: {
          title: "Supportare Linemate",
          body: "Questo ci aiuta a continuare a migliorare l'app e le funzionalità che usi di più.",
        },
        relevantContent: {
          title: "Vedere contenuti più pertinenti",
          body: "Usiamo questi dati per mostrarti offerte, trend e annunci più pertinenti.",
        },
      },
    },
  },
};